import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFoundPage = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] py-12 px-4 text-center">
            <h1 className="text-6xl font-bold text-primary-600 mb-4">404</h1>
            <h2 className="text-2xl font-semibold mb-6">頁面不存在</h2>
            <p className="text-gray-600 max-w-md mb-8">
                很抱歉，您所尋找的頁面不存在或可能已被移除。
            </p>
            <Link
                to="/"
                className="flex items-center px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
                <Home size={20} className="mr-2" />
                返回首頁
            </Link>
        </div>
    );
};

export default NotFoundPage;